import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export async function createAutomationJob(payload) {
  const { data } = await client.post('/automation/jobs', payload);
  return data;
}

export async function getAutomationJobStatus(id) {
  const { data } = await client.get(`/automation/jobs/${id}/status`);
  return data;
}

export async function listAutomationJobs(limit = 30) {
  const { data } = await client.get('/automation/jobs', { params: { limit } });
  return data;
}

export async function deleteAutomationJob(id) {
  const { data } = await client.delete(`/automation/jobs/${id}`);
  return data;
}

export async function retryAutomationJob(id) {
  const { data } = await client.post(`/automation/jobs/${id}/retry`);
  return data;
}
